import { useEffect, useRef } from 'react'
import { useModal } from 'app/components'

/**
 * Recarrega os dados da página quando um modal aberto por ela fecha. Substitui o padrão
 * `queryKey` com `isOpen` + `enabled: !isOpen`, que deixava a página sem dados (e em estado de
 * erro) enquanto o modal estava aberto.
 */
export const useRecarregaAoFecharModal = (recarregar: () => unknown) => {
  const { isOpen } = useModal()
  const estavaAberto = useRef(isOpen)
  const recarregarRef = useRef(recarregar)
  recarregarRef.current = recarregar

  useEffect(() => {
    if (estavaAberto.current && !isOpen) recarregarRef.current()
    estavaAberto.current = isOpen
  }, [isOpen])
}
